import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import Tabs from '@r1-frontend/ui-react/components/tabs/tabs';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const AliasContent = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 1280px;
    color: black;
    ${FONTS.XS};
    white-space: pre-wrap;

    @media (min-width: ${wideBreakpoints.mobile}) {
        ${FONTS.S};
        padding: 0 16px;
    }

    a {
        color: ${COLORS.Link};
    }
`;

export const ContentWrapper = styled.div`
    display: flex;
    flex-direction: row;
    margin-top: 6px;
`;

export const ContentLabel = styled.div`
    color: ${COLORS.GRAY_DARK};
    display: flex;
    margin-right: 5px;
`;

export const StyledTabs = styled(Tabs)`
    > div:first-child {
        width: fit-content;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        > div:first-child {
            width: 100%;
            overflow-x: scroll;
        }

        > div:last-child {
            padding-left: 16px;
            padding-right: 16px;
        }

        & > div:not(:last-child) {
            transition: color 0.3s ease 0s;
            padding-left: 16px;
            padding-right: 16px;
            margin: 0px;
            color: ${COLORS.TextPrimary};
        }
    }
`;
